module.exports = __webpack_public_path__ + "static/logo7_v1_final_optimised-4afc85a0b47b2b622a6c67865d88363a.svg";